import { definitionLabel } from 'styles/base-classes';
import styled from 'styled-components/macro';

import Box from 'components/elements/Box';
import {
  Header,
  KPIListItemRow,
  KPIListItemContentItemColumn,
} from 'components/data-containers/KPIs/shared/index';
import { Grid } from 'components/Overview/Container/shared.style';
import { Group } from 'components/base/KeyValuePair/KeyValuePair';

export const HeaderWrapper = styled('div')<any>`
  ${({ isMobileView }): string => isMobileView && 'margin-bottom: -2em;'}
`;

export const HeaderTitle = styled(Header)`
  ${definitionLabel};
  margin-bottom: ${({ theme }): string => theme.spacing.small};
  font-weight: 600;
  color: ${({ theme }): string => theme.NightBlue};
`;

export const CountriesWrapper = styled(KPIListItemRow)`
  h4 {
    margin-bottom: 0;
  }
  ol {
    margin-top: 0.75em;
    margin-bottom: 1em;

    li {
      @media screen and (max-width: 40rem) {
        font-size: 0.8em;
        font-weight: 600;
        line-height: 1.85;
      }
    }
  }

  @media screen and (max-width: 40rem) {
    display: flex;
    flex-direction: column;

    ${KPIListItemContentItemColumn} {
      padding-top: 0.5em;

      ol {
        margin-bottom: 0.5em;
      }
    }
  }
`;

export const TrendChartWrapper = styled(Box)`
  padding-top: 1.5em;

  @media screen and (max-width: 40rem) {
    margin: 0 -0.7em;
  }
`;

export const GridBox = styled(Grid)<any>`
  @media screen and (max-width: 50rem) {
    > ${Box} {
      padding: 0;
    }
  }
  @media screen and (max-width: 40rem) {
    display: flex;
    flex-direction: column;
    margin-top: -2em;
  }

  ${Group} {
    @media screen and (max-width: 920px) {
      margin: 0.6em 0.5em !important;
    }
  }
`;
